import { Component, Input, OnInit } from '@angular/core';
import { elementAt } from 'rxjs/operators';
import { PageElementViewModel, ConferenceViewModel, ConferenceViewModelWithDetails, InstructorViewModel, OrganizationViewModel } from 'src/app/_models/generatedModels';
import { InstructorService, OrganizationCMSService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-conference-speaker-listing',
  templateUrl: 'conference-speaker-listing.component.html',
})
export class ConferenceSpeakerListingComponent implements OnInit {
  initialized = false;

  instructors: InstructorViewModel[];
  @Input() conference: ConferenceViewModel;
  @Input() element: PageElementViewModel;
  @Input() organization: OrganizationViewModel;

  constructor(private instructorService: InstructorService, private orgCMS: OrganizationCMSService) {}

  ngOnInit(): void {
    let ids: Array<number> = [];

    if (this.element.data) {
      ids = JSON.parse(this.element.data);
    }

    if (this.conference) {
      this.instructorService.getInstructorsForConference(this.conference.id).subscribe((result) => {
        this.instructors = result.filter(function (item) {
          return ids.indexOf(item.id) === -1;
        });
        this.initialized = true;
      });
    } else {
      this.orgCMS.getInstructorsForNonConferenceCourseEvents(this.organization.id.toString()).subscribe((result) => {
        this.instructors = result.filter(function (item) {
          return ids.indexOf(item.id) === -1;
        });
        this.initialized = true;
      });
    }
  }
}
